module.exports = __webpack_public_path__ + "static/media/fmlogo.50b941c4.png";